// extracted by mini-css-extract-plugin
export default {"button":"Map_button__TmP6T","active":"Map_active__p0wwq","body":"Map_body__MCvxA","show":"Map_show__HBGem"};